<div class="govuk-grid-row">
  <div class="govuk-grid-column-two-thirds">
    <h2 class="govuk-heading-l">Advice Index</h2>

    <ng-template  #invalidData>
      <div>
          No advice sets available
      </div>
    </ng-template>

    <ng-container *ngIf="adviceSetLibrary.groups.length; else invalidData">
      <ng-container *ngFor="let group of adviceSetLibrary.groups">
        <div class="govuk-heading-m">{{group.name}}</div>
        <div class="group-info govuk-body-s caption">{{group.description}}</div>

        <ul class="govuk-list govuk-!-font-size-16">
          <li *ngFor="let item of group.items">
            <a class="theme-link" href="#" [routerLink]="item.slug || item.id" [title]="item.description">
              {{item.name}}
            </a>
          </li>
        </ul>
      </ng-container>
    </ng-container>
  </div>
</div>
